import _ from "../../../../@lodash";

const PageModel = (data) =>
  _.defaults(data || {}, {
    title: "",
    label: "",
    classification: "static",
    progress: {
      development: 0,
      production: 0,
    },
    status: {
      development: "not_started",
      production: "not_started",
    },
    order: 0,
    user: "",
    section: "",
    template: "",
    screen: "",
    back: "",
    next: "",
    content: {},
  });

export default PageModel;
